export default __webpack_public_path__ + "static/media/testing-talks.31862fa0.png";